import { mapActions, mapGetters } from "vuex";

export const roleMixin = {
  computed: {
    ...mapGetters("auth", ["getRole"])
  },

  methods: {
    ...mapActions("teams", ["updateTeamSearch"]),
    ...mapActions("leads", ["updateLeadSearch"]),
    ...mapActions("realEstate", ["updateRealEstateSearch"]),
    ...mapActions("properties", ["updatePropertySearch"]),
    ...mapActions("realtors", ["updateRealtorSearch"]),

    hasPermission(roles) {
      return roles.includes(this.getRole);
    },

    cleanData() {
      this.updateTeamSearch(null);
      this.updateLeadSearch(null);
      this.updateRealEstateSearch(null);
      this.updatePropertySearch(null);
      this.updateRealtorSearch(null);
    },

    formatDate(date) {
      return this.$moment(date).format("YYYY-MM-DD");
    }
  }
};
